/**
 * Reads `isLocked` / `isFrozen` from PageElement `base` wire objects (protobuf JSON).
 * Accepts camelCase, snake_case, and legacy boolean coercions used in checkpoints.
 */

function asPageElementBoolean(value: unknown): boolean | null {
  if (typeof value === 'boolean') return value
  if (typeof value === 'number') {
    if (value === 1) return true
    if (value === 0) return false
  }

  if (typeof value === 'string') {
    if (value.toLowerCase() === 'true') return true
    if (value.toLowerCase() === 'false') return false
  }

  return null
}

export function readIsLockedFromPageElementBase(base: Record<string, unknown>): boolean {
  return asPageElementBoolean(base.isLocked ?? base.is_locked ?? base.IsLocked) ?? false
}

export function readIsFrozenFromPageElementBase(base: Record<string, unknown>): boolean {
  return asPageElementBoolean(base.isFrozen ?? base.is_frozen ?? base.IsFrozen) ?? false
}

export function readIgnoreTextWrapFromPageElementBase(base: Record<string, unknown>): boolean {
  return (
    asPageElementBoolean(base.ignoreTextWrap ?? base.ignore_text_wrap ?? base.IgnoreTextWrap) ??
    false
  )
}
